<template>
  <div class="collapse-component" :class="{ collapsed: isCollapsed }">
    <div class="collapse-button-container">
      <slot name="header">
        <b-btn class="collapse-button text-uppercase w-100" v-on:click="collapseContainer">
          <span class="collapse-button-text"> {{ title || "No-Title" }}</span>
          <span class="collapse-button-arrow" :class="{ collapsed: isCollapsed, collapsing: isCollapsing }"><i class="cil-chevron-top-alt"></i></span>
        </b-btn>
      </slot>
    </div>
    <div class="collapse-container" :class="[{ collapsed: isCollapsed, collapsing: isCollapsing }, containerClass]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      isCollapsed: false,
      isCollapsing: false
    };
  },
  props: {
    title: { type: String, required: true },
    collapsed: Boolean,
    containerClass: String
  },
  methods: {
    collapseContainer() {
      this.isCollapsed = !this.isCollapsed;
    }
  },
  mounted() {
    this.isCollapsed = this.collapsed;
  }
};
</script>
